import { PlusCircleFilled } from "@ant-design/icons";
import { useRef, useState } from "react";
import styles from "./index.module.less";
import HBSelect from "./select";

export default function AddSelect({
  emptyText,
  emptySearchText,
  onCreate,
  desc,
  ...props
}) {
  const [searchWord, setSearchWord] = useState("");

  const ref = useRef(null);

  const filterOption = (value, option) => {
    return option.label?.includes(value);
  };

  return (
    <HBSelect
      {...props}
      ref={ref}
      showSearch
      allowClear
      onSearch={(v) => {
        setSearchWord(v);
        props.onSearch && props.onSearch(v);
      }}
      filterOption={filterOption}
      dropdownRender={(option) => {
        const filterResult = props.options.filter((item) =>
          filterOption(searchWord, item)
        );

        if (searchWord === "" && filterResult.length === 0) {
          return (
            <div
              className={styles.emptyText}
              onClick={() => {
                // 避免点击导致输入框失去焦点，导致focus状态消失，label下移问题
                ref.current.setFocus(true);
              }}
            >
              {emptyText}
            </div>
          );
        }

        if (searchWord === "" && filterResult.length) {
          return (
            <div>
              <div
                className={styles.searchContent}
                onClick={() => {
                  // 避免点击导致输入框失去焦点，导致focus状态消失，label下移问题
                  ref.current.setFocus(true);
                }}
              >
                {desc}
              </div>
              {option}
            </div>
          );
        } else {
          return (
            <div>
              {filterResult.length ? option : null}
              <div
                className={styles.emptySearchContent}
                onClick={() => {
                  onCreate && onCreate(searchWord, ref);
                  ref.current.blur();
                }}
              >
                <PlusCircleFilled />
                {emptySearchText} ”{searchWord}“
              </div>
            </div>
          );
        }
      }}
      onSelect={(value, option) => {
        setSearchWord("");
        props.onSelect && props.onSelect(value, option);
      }}
      notFoundContent={"空"}
    />
  );
}
